<template>
  <div class="home">
    <home-hero></home-hero>
    <home-whats-happening></home-whats-happening>
    <home-top-tour></home-top-tour>
    <home-popular-attraction></home-popular-attraction>
    <home-mak-and-greet></home-mak-and-greet>
    <home-social-media></home-social-media>
    <!-- <home-accessibility></home-accessibility> -->
  </div>
</template>

<script>
import axios from 'axios';
import HomeLP from '@/LoadingPlaceholders/HomeLP';
import HomeHero from '@/components/HomeHero';
import HomeWhatsHappening from '@/components/HomeWhatsHappening';
import HomeTopTour from '@/components/HomeTopTour';
import HomePopularAttraction from '@/components/HomePopularAttraction';
import HomeMakAndGreet from '@/components/HomeMakAndGreet';
import headerUpdater from '@/mixins/headerUpdater'
import HomeSocialMedia from '@/components/HomeSocialMedia';
import HomeAccessibility from '@/components/HomeAccessibility';
import ingore404 from '@/utils/ingore404';
// import HomeFollowTheStar from '@/components/HomeFollowTheStar';

export default {
  name: 'home-view',
  loadingPlaceholder: HomeLP,
  mixins: [headerUpdater({ firePageLoadedEvent: true })],
  asyncData({ i18n, store, route }) {
    const { locale } = i18n;
    return Promise.all([
      store.dispatch('sightmap/FETCH_OVERVIEW', {
        sightMapType: 'tour',
        category: 'macao-full-of-fun',
        i18n
      }),
    ]);
  },
  components: {
    HomeHero,
    HomeWhatsHappening,
    HomeTopTour,
    HomePopularAttraction,
    HomeMakAndGreet,
    HomeSocialMedia,
    // HomeFollowTheStar,
    HomeAccessibility
  }
}
</script>